// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

/**
 * ActivityLogSkeleton
 *
 * Shared loading skeleton for the activity feeds (full `ActivityLogPage` and
 * the client-scoped `ClientActivityTab`). Renders a small stack of placeholder
 * rows to match the item layout while data is being fetched.
 */

export function ActivityLogSkeleton() {
  return (
    <div className="activity-log__skeleton">
      {['s1', 's2', 's3', 's4', 's5'].map((id) => (
        <div key={id} className="activity-log__skeleton-item">
          <div className="activity-log__skeleton-icon" />
          <div className="activity-log__skeleton-content">
            <div className="activity-log__skeleton-line activity-log__skeleton-line--short" />
            <div className="activity-log__skeleton-line activity-log__skeleton-line--long" />
          </div>
          <div className="activity-log__skeleton-timestamp" />
        </div>
      ))}
    </div>
  );
}
